import Box from '@mui/material/Box'; 
import Stack from '@mui/material/Stack'; 
import { grey } from '@mui/material/colors'; 
import FlashingDiv from './FlashingDiv';

export type RecentOrdersSkeletonProps = {
    count: number
}


export default function RecentOrdersSkeleton(props: RecentOrdersSkeletonProps){
    const count = props.count; 
    //@ts-ignore
    const listOfSkeletons = Array(count).fill().map((x, index) => <IndSkeleton key={String(index)}/>)
    return (
        <>{listOfSkeletons}</>
    )
}

function IndSkeleton() {

    return (
        <Box sx={{marginTop: 1}}>
            <Stack sx={{width: '100%', borderBottom: 1, borderColor: 'lightgray'}}>
                <Stack direction="row" alignItems="center" sx={{width: '100%', marginBottom: "2px"}} >
                    <FlashingDiv sx={{fontSize: '.8rem', backgroundColor: grey[200], width: '12rem', borderRadius: 1}}>
                        &nbsp;
                    </FlashingDiv>
                    {/** Empty div with flexGrow to fill blank space */}
                    <Box sx={{flexGrow: 2}}></Box>
                    <FlashingDiv sx={{fontSize: '1.2rem', backgroundColor: grey[200], width: '3rem', borderRadius: 1}}>
                        &nbsp;
                    </FlashingDiv>
                </Stack>
                <Stack direction="row" alignItems="center" sx={{width: '100%', marginBottom: "3px"}}>
                    <FlashingDiv sx={{fontSize: '1.8rem', width: '12rem', backgroundColor: grey[200], borderRadius: 1}}>
                        &nbsp;
                    </FlashingDiv>
                    {/** Empty div with flexGrow to fill blank space */}
                    <Box sx={{flexGrow: 2}}></Box>
                    <FlashingDiv sx={{ fontSize: '1.8rem', fontWeight: 'bold', backgroundColor: grey[200], borderRadius: 1, width: '8rem'}}>
                        &nbsp;
                    </FlashingDiv>
                </Stack>
                <Stack direction="row" alignItems="center" sx={{width: '100%', marginBottom: "5px"}} >
                    <FlashingDiv sx={{fontSize: '.6rem', backgroundColor: grey[200], width: '12rem', borderRadius: 1}}>
                        &nbsp;
                    </FlashingDiv>
                    {/** Empty div with flexGrow to fill blank space */}
                    <Box sx={{flexGrow: 2}}></Box>
                </Stack>
            </Stack>
        </Box>
    )   
}